export const homePath = '/';
export const webPagePath = '/web';
